export default __webpack_public_path__ + "static/media/card-envelope.7a597af0.jpg";